module.exports = __webpack_public_path__ + "static/media/pointer.a944ca74.png";